import { render, staticRenderFns } from "./FormulateVendorContactPicker.vue?vue&type=template&id=5af5ce90"
import script from "./FormulateVendorContactPicker.vue?vue&type=script&lang=js"
export * from "./FormulateVendorContactPicker.vue?vue&type=script&lang=js"
import style0 from "./FormulateVendorContactPicker.vue?vue&type=style&index=0&id=5af5ce90&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports